export const COMPONENT_NAME = 'TwoColumnSubLayout';
export const LEFT_SECTION = 'LeftTwoColumnSubLayoutSection';
export const RIGHT_SECTION = 'RightTwoColumnSubLayoutSection';
